
import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { EConvertType } from "../@types/Convert";

export interface PageState {
  initState: number;
  loading: boolean;
  modals: {
    payment: {
      show: boolean;
      type: EPaymentType | null;
      convertType: EConvertType | null;
      data: IPaymentObjectTranslate | IPaymentObjectConvertSrtToFCPXML | IPaymentObjectConvertXMLToFCPXML | null;
    }
  }
}

const initialState: PageState = {
  initState: 0,
  loading: false,
  modals: {
    payment: {
      show: false,
      type: null,
      convertType: null,
      data: null
    }
  }
};

export const LayoutSlice = createSlice({
  name: "layout",
  initialState,
  reducers: {
    SetInitState(state, action: PayloadAction<number>) {
      state.initState = action.payload;
    },
    SetLoading(state, action) {
      state.loading = action.payload;
    },
    SetModalPayment(state, action: PayloadAction<ISetModalPayment>) {
      state.modals.payment.show = action.payload.show;
      state.modals.payment.type = action.payload.type || null;
      state.modals.payment.convertType = action.payload.convertType || null;
      state.modals.payment.data = action.payload.data || null;
    }
  }
});

export const { 
  SetInitState, SetLoading,

  // Modals
  SetModalPayment
} = LayoutSlice.actions;

export default LayoutSlice.reducer;

export interface ISetModalPayment {
  show: boolean;
  type?: EPaymentType;
  convertType?: EConvertType;
  data?: IPaymentObjectTranslate | IPaymentObjectConvertSrtToFCPXML | IPaymentObjectConvertXMLToFCPXML;
}

export enum EPaymentType {
  Translate = 'Translate',
  Convert = 'Convert'
}

export interface IPaymentObjectTranslate {
  email: string;
  fileName: string;
  fileUrl: string;
  sourceLang: string;
  targetLang: string;
}

export interface IPaymentObjectConvertSrtToFCPXML {
  email: string;
  fileName: string;
  fileUrl: string;
  videoWidth: number;
  videoHeight: number;
  videoFPS: number;
}

export interface IPaymentObjectConvertXMLToFCPXML {
  email: string;
  fileName: string;
  fileUrl: string;
}